import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AbsenceListComponent } from './absence/absence-list/absence-list.component';
import { LeaveComponent } from './leave/leave.component';
import { RegularComponent } from './regular/regular.component';
import { ManageLeaveComponent } from './leave/manage-leave/manage-leave.component';
import { LeaveApprovalComponent } from './leave/leave-approval/leave-approval.component';
import { LeavesComponent } from './leave/leaves/leaves.component';
import { ManageRegularComponent } from './regular/manage-regular/manage-regular.component';
import { RegularListComponent } from './regular/regular-list/regular-list.component';
import { RegularApprovalComponent } from './regular/regular-approval/regular-approval.component';
import { VacayComponent } from './vacay/vacay.component';
import { ModuleGuard } from 'src/app/shared/guards/module.guard';

const routes: Routes = [
  {
    path: 'leave',
    component: LeaveComponent,
    canActivate:[ModuleGuard],
    data: {
      title: 'leave',
      modules:['LEAVE']
    }
  },
  {
    path: 'manageLeave',
    component: ManageLeaveComponent,
    data: {
      title: 'manageLeave'
    }
  },
  {
    path: 'leave-list',
    component: LeavesComponent,
    data: {
      title: 'leave-list',

    }
  },
  {
    path: 'leave-approval',
    component: LeaveApprovalComponent,
    data: {
      title: 'leave-approval'
    }
  },
  {
    path: 'manageRegular',
    component: ManageRegularComponent,
    data: {
      title: 'manageRegular'
    }
  },
  {
    path: 'regular-list',
    component: RegularListComponent,
    data: {
      title: 'regular-list',
      
    }
  },
  {
    path: 'regular-approval',
    component: RegularApprovalComponent,
    data: {
      title: 'regular-approval'
    }
  },
  {
    path: 'regular',
    component: RegularComponent,
    canActivate:[ModuleGuard],
    data: {
      title: 'regular',
      modules:['REGULARIZATION']
    }
  },
  {
    path: 'absence-list',
    component: AbsenceListComponent,
    canActivate:[ModuleGuard],
    data: {
      title: 'absence-list',
      modules:['ABSENCE']
    }
  },
  {
    path: 'vacay',
    component: VacayComponent,
    canActivate:[ModuleGuard],
    data: {
      title: 'vacay',
      modules:['REVIEW']
    }
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppearenceRoutingModule { }
